module.exports = __webpack_public_path__ + "img/shehuizerenbg.f82daf43.png";